var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8lrwTfZWt91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5333 3000",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "d306c5d61aaf4262ba098e8ae8fb2132",
    "export-id": "8645e74cdb874c2887b9719c2dd7abc4",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.102814 0 0 11.638683-1042.185738-241.797265)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0-.1 0 371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1815,3210c-196-44-340-124-493-274-186-181-276-365-303-617-13-117-3-252,26-363c93-355,406-657,763-737c155-34,374-27,531,17c276,78,529,299,652,569c66,147,98,349,79,511-28,243-108,417-274,592-157,166-336,267-546,306-114,22-330,20-435-4Zm466-153c168-47,318-145,438-288c217-258,260-620,110-924-58-119-140-220-246-305-281-226-678-254-995-69-114,67-308,265-308,315c0,9,31,74,68,143c38,69,120,222,182,339c63,116,117,212,120,212c4,0,181-317,188-340c2-5-39-11-95-12l-98-3v-55-55l135-5l134-5l61-110l60-110l209-9c179-7,219-6,275,8c157,38,278,129,337,253c31,64,37,89,42,162c12,223-107,376-326,420-69,14-576,15-567,1c3-5,19-10,34-10c55,0,64-17,70-136l6-109l59-108c32-60,59-107,61-105c1,2,5,94,9,206c3,112,9,208,12,214c10,16,200,3,254-16c109-40,189-123,225-234c14-41,17-76,13-155-8-160-52-238-167-291-38-17-66-21-161-21-113,0-117,1-165,32-28,18-64,47-82,65-17,18-118,183-224,366l-192,333-96-3-95-3-185-322c-101-178-188-323-192-323-13,0-29,124-29,222c0,246,75,425,254,604c150,150,298,228,486,254c105,14,283,4,381-23Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24678 0 0 1.30196-1142.21-547.148)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.948913 0 0 0.968669 207.103 59.7139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 78.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 39.3465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.5335 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.82 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.6067 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5098,2096c-16-8-24-22-26-44-3-26,1-34,22-43c35-16,74-4,82,25c12,50-32,85-78,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3450,2048c-11-27-90-313-90-328c0-5,24-10,54-10c51,0,53,1,62,33c9,30,13,32,54,32s45-2,54-32c9-32,10-33,67-33c42,0,57,3,54,13-2,6-22,77-45,157-58,206-47,190-130,190-64,0-71-2-80-22Zm98-126c16-80,16-82-18-82-18,0-30,5-30,13c0,28,23,127,29,127c4,0,12-26,19-58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4127,2063c-4-3-7-84-7-180v-173h103c87,0,110,3,147,23c61,31,83,65,88,137c10,137-71,200-257,200-37,0-71-3-74-7Zm206-114c24-29,22-90-4-123-16-20-29-26-60-26h-39v83c0,46,3,87,8,91c13,14,77-3,95-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3763,2053c-23-4-23-7-23-139c0-177,13-204,95-204c53,0,65,9,65,46c0,29-3,34-24,34-33,0-38,20-36,138c3,139,4,132-27,131-16-1-38-4-50-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4892,2049c-23-9-23-10-20-148c3-132,4-141,27-165c45-47,147-30,139,24-2,16-11,26-28,30-25,6-25,6-28,138l-3,132-32-1c-18,0-42-4-55-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5282,2053c-23-5-23-5-20-148c3-136,4-145,27-169c45-47,147-30,139,24-2,16-11,26-28,30-25,6-25,6-28,138l-3,132-32-1c-18-1-42-4-55-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4593,1963c-34-7-81-59-89-98-9-50,2-83,41-122c28-28,40-33,78-33c27,0,49,6,57,15c7,8,16,15,21,15s9-7,9-15c0-12,13-15,55-15h56l-3,128-3,127h-50c-45,0-50-2-53-23l-4-24-21,20c-24,23-60,32-94,25Zm95-89c41-29,23-84-28-84-32,0-50,17-50,46c0,20,32,54,50,54c3,0,16-7,28-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5077,1964c-4-4-7-47-7-96c0-93,14-140,45-152c26-10,90-7,102,5c15,15,3,61-18,66-16,4-19,18-21,92l-3,86-45,3c-25,2-49,0-53-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3924,1855c-14-34,3-45,71-45h66l-3,28c-3,26-6,27-66,30-49,2-64,0-68-13Z"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/aa.3962177944ac75c664945d1457b550f7.svg";
export { ForwardRef as ReactComponent };